import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-title',
  templateUrl: './modal-title.component.html',
  styleUrls: ['./modal-title.component.css']
})
export class ModalTitleComponent implements OnInit {

  @Input() public state: string;

  constructor() { }

  ngOnInit() {
  }

}
